import React, { Component } from 'react'
import moment from 'moment'
import { Table, Checkbox } from 'semantic-ui-react'
import { Map, List, fromJS } from 'immutable'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import _ from 'lodash'
const { Header, Row, HeaderCell, Cell, Body, Footer } = Table

let directionFix = {
  asc: 'ascending',
  desc: 'descending',
}

class TableContainer extends Component {
  static defaultProps = {
    columns: [],
    dataId: false,
    header: true,
    sortBy: false,
    sortDir: 'asc',
    striped: false,
    limit: 25,
    page: 1,
    emptyContent: 'Ei tuloksia',
    linkRoot: '',
    search: false,
    data: List(),
  }

  render = () => {
    let {
      columns,
      header,
      emptyContent,
      search,
      dataId,
      linkRoot,
      sortBy,
      sortDir,
      crud,
      texts,
      editing,
      sort,
      onAction,
      editId,
      groupBy = false,
      data = List(),
      context,
      ...customProps
    } = this.props

    let tableList = []

    let classes = []
    if (editing) classes.push('datatable-table--editing')

    let groupByColumn = groupBy ? columns.find(({ name }) => name === groupBy) : false
    if (groupByColumn) {
      let { options: groupOptions = [] } = groupByColumn
      let groupped = {}
      data.forEach(i => {
        let groupData = i.getIn(groupBy.split('.'), undefined)
        groupped[groupData] = (groupped[groupData] || List()).push(i)
      })

      tableList = Object.keys(groupped).map(groupData => ({
        title: groupOptions[groupData] || groupData,
        data: groupped[groupData],
      }))
    } else {
      tableList.push({ data })
    }

    return tableList.map(({ title = false, data = List() }, key) => {
      return (
        <div className="datatable-table-group" key={key}>
          {title ? (
            <div className="datatable-table-group-title">
              <span>{title}</span>
            </div>
          ) : null}
          <Table sortable striped selectable className={classes.join(' ')}>
            {header ? (
              <Header>
                <Row>
                  <th width="10"></th>
                  {columns.map(({ label, name, sortable, align, width, id }, key) => {
                    if (name === groupBy) return null

                    let cellProps = {
                      key,
                      style: {},
                    }

                    if (align) cellProps.textAlign = align

                    if (width) cellProps.style.width = `${width}px`

                    if (sortable) {
                      cellProps.sorted = sortBy === name ? directionFix[sortDir] : null
                      cellProps.onClick = e =>
                        e.preventDefault() &
                        sort(name, sortBy === name ? (sortDir === 'asc' ? 'desc' : 'asc') : sortDir)
                    }

                    return <HeaderCell {...cellProps}>{label}</HeaderCell>
                  })}
                </Row>
              </Header>
            ) : null}
            <Body>
              {data.size ? (
                data.map((item, key) => {
                  let id = item.get(dataId, false)
                  if (!id) return false

                  let classes = []
                  if (editId === id) classes.push('datatable-table-active-row')

                  return (
                    <Row key={id} className={classes.join(' ')}>
                      <td></td>
                      {columns.map((column, key) => {
                        if (column.name === groupBy) return null

                        let content = item.getIn(column.name.split('.'), '')
                        if (typeof column.render === 'function')
                          content = column.render.call(null, item, column, context)

                        if (column.date) {
                          if (!content) {
                            content = '(Aikaa ei ole asetettu)'
                          } else if (column.date === 'timeago') {
                            content = moment(content, 'YYYY-MM-DD HH:mm:ss.SSSZZ').fromNow()
                          } else if (column.date === true) {
                            content = moment(content, 'YYYY-MM-DD HH:mm:ss.SSSZZ').format('DD.MM.YYYY - HH:mm')
                          } else {
                            content = moment(content, 'YYYY-MM-DD HH:mm:ss.SSSZZ').format(column.date)
                          }
                        }

                        if (typeof column.link === 'function')
                          content = <Link to={column.link.call(null, item, column)}>{content}</Link>

                        if (column.options && column.options[content]) content = column.options[content]

                        if (Array.isArray(column.options)) {
                          let option = column.options.find(o => o.value === content)
                          if (option) content = option.text
                        }

                        let cellProps = {
                          key: `${id}-${column.name}`,
                          style: {},
                        }

                        let classes = []

                        if (crud && column.id) {
                          classes.push('datatable-id')
                          cellProps.onClick = e => {
                            e.preventDefault()
                            onAction('edit', { id })
                          }
                        }

                        if (column.width) cellProps.style.width = `${column.width}px`

                        if (column.align) cellProps.textAlign = column.align

                        cellProps.className = classes.join(' ')

                        return (
                          <Cell {...cellProps}>
                            <div>{content}</div>
                          </Cell>
                        )
                      })}
                    </Row>
                  )
                })
              ) : (
                <Row>
                  <Cell colSpan={columns.length + 1} style={{ textAlign: 'center' }}>
                    {emptyContent}
                  </Cell>
                </Row>
              )}
            </Body>
          </Table>
        </div>
      )
    })
  }
}

export default withRouter(TableContainer)
